import {defineStore} from 'pinia';
import { axiosInstance as axios } from '../plugins/axios';

import { useOrderStore } from './orderStore';

export const useDiscountStore = defineStore('discountStore', {
    state: () => ({
        couponCode: null,
        giftCardCode: '',
        coupon: null,
        giftCard: null,
    }),
    persist: {
        pick: ['couponCode', 'giftCardCode', 'coupon', 'giftCard']
    },
    getters: {
        couponDiscountAmount: (state) => {
            const orderStore = useOrderStore();
            const subtotal = orderStore.subtotalAmount || 0;
            const discountType = state.coupon?.discount_type;
            
            let discountAmount = 0;
            if (state.coupon) {
                if (discountType === 'percent') {
                    discountAmount = (subtotal * state.coupon.discount_amount) / 100;
                } else if (discountType === 'amount') {
                    discountAmount = state.coupon.discount_amount;
                }
            }

            return discountAmount;
        }
    },
    actions: {
        setCoupon(coupon) {
            this.coupon = coupon;
        },
        setGiftCard(giftCard) {
            this.giftCard = giftCard;
        },

        async fetchCouponDetails() {
            try {
                const response = await axios.get(`/coupons/${this.couponCode}/getByCode`);
                this.setCoupon(response.data);
                return response.data;
            } catch (error) {
                console.error("Error fetching coupon details:", error);
                this.setCoupon(null);
                return error;
            }
        },

        async fetchGiftCardDetails() {
            try {
                const response = await axios.get(`/gift-cards/${this.giftCardCode}/getByCode`);
                this.setGiftCard(response.data);
                return response.data;
            } catch (error) {
                console.error("Error fetching gift card details:", error);
                this.setGiftCard(null);
                return error;
            }
        }
    },
});